module.exports = __webpack_public_path__ + "static/media/mongodb-logo.36f9729f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mongodb-logo.png
// module id = 137
// module chunks = 0